import React from 'react';
import CalculateTotal from './CalculateTotal';

function capitalizeFirstLetter(string) {
	const result = string.replace(/([A-Z])/g, " $1");
	return result.charAt(0).toUpperCase() + result.slice(1);
}

const ConsumoMobile = ({ dataTable, calculationType, calculatePercentage = false }) => {
	const cities = [
		"Asunción",
		"Concepción",
		"San Pedro",
		"Cordillera",
		"Guairá",
		"Caaguazú",
		"Caazapá",
		"Itapúa",
		"Misiones",
		"Paraguarí",
		"Alto Paraná",
		"Central",
		"Ñeembucú",
		"Amambay",
		"Canindeyú",
		"Presidente Hayes",
		"Boquerón",
		"Alto Paraguay"
	];

	const masterColumnOrder = [
		"origen",
		"categoria",
		"tipo",
		"cantidad",
		"pesoProm",
		"precioMin",
		"precioMax",
		"precioProm",
		"precioUs",
		"precioTotalProm"
	];

	const activeColumns = dataTable.length > 0
		? masterColumnOrder.filter(key => Object.prototype.hasOwnProperty.call(dataTable[0], key))
		: [];

	function roundNumber(number) {
		if (typeof (number) === "number") {
			let rounded = Math.round(number);
			return rounded.toLocaleString();
		}
		else {
			return number;
		}
	}

	return (
		<div>
			{dataTable.length > 0 ?
				<div className="consumoMobileContainer">
					{dataTable.map((data, dataIndex) => (
						<div key={dataIndex} className="consumoMobileWrapper">
							{activeColumns.map((key, innerIndex) => {
								const inner = data[key];
								return (
									<div key={innerIndex} className="consumoMobileContent">
										<p>{capitalizeFirstLetter(key)}</p>
										{key === "origen" ?
											<p>{cities[inner]}</p>
											: key === "tipo" ?
												<p>{inner}</p>
												: ["precioMax", "precioMin", "precioProm"].includes(key) ?
													<p>
														{calculatePercentage ?
															<span>{roundNumber((inner * 0.05) + inner)}</span>
															:
															<span>{roundNumber(inner)}</span>
														}
													</p>
													:
													<p>{roundNumber(inner)}</p>
										}
									</div>
								);
							})}
						</div>
					))}
					<CalculateTotal dataTable={dataTable} calculationType={calculationType} />
				</div>
				:
				<p className="align-center">No hay información disponible.</p>
			}
		</div>
	)
}

export default ConsumoMobile;
